var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "34px",
    viewBox: "0 0 30 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "14.6626517 11.5314213 0.00376151897 11.5314213 0.00376151897 0.0638415561 29.3215419 0.0638415561 29.3215419 11.5314213"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(15.500000, 17.500000) rotate(-360.000000) translate(-15.500000, -17.500000) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "003-lawyer",
    transform: "translate(0.023245, 0.714997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 21.452309)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7943027,3.43778082 L26.6807048,3.40453941 C25.0214361,2.94656804 25.7971867,2.50669908 25.0586752,2.21783375 C22.4374607,1.19108631 21.755748,0.452366707 21.5814016,0.103074157 C21.5755086,0.0909629436 21.5716217,0.0769190897 21.5657286,0.0638415561 L9.09290788,0.0638415561 C9.08701484,0.0769190897 9.08212486,0.091027365 9.07623182,0.103074157 C8.90188541,0.452366707 8.2201101,1.19115073 5.59989868,2.21783375 C4.86138712,2.50669908 4.3001058,2.94656804 2.64077439,3.40453941 L2.52617345,3.43778082 C1.01573551,3.95109013 0,5.39045631 0,7.01509829 L0,11.5314213 L29.3215419,11.5314213 L29.3215419,7.01509829 C29.3215419,5.39045631 28.3048033,3.95109013 26.7943027,3.43778082",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    fill: "#C8CDD0",
    points: "17.992411 20.7542392 12.6975088 19.923848 10.4691223 24.7622778 15.3794718 32.9837303 20.2256875 25.42556 17.992411 20.7542392"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-5",
    fill: "#2F424F",
    points: "16.7679112 25.42556 13.9914713 25.42556 13.1197393 28.8608928 15.3794718 32.9837303 17.604473 28.8608928 16.7679112 25.42556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2361576,23.2796205 L15.6929318,20.6817652 C15.5626578,20.4633124 15.3246164,20.3365312 15.0748515,20.3546336 C14.8260897,20.372736 14.6076082,20.5317923 14.5086802,20.7673168 L13.3782811,23.4487265 C13.3420451,23.5353088 13.3224225,23.6278823 13.3224225,23.7214865 L13.3224225,25.4254956 C13.3224225,25.8050018 13.6221529,26.1119051 13.9914713,26.1119051 L16.6665383,26.1119051 C17.0362956,26.1119051 17.3340825,25.8049373 17.3340825,25.4254956 L17.3340825,23.6379964 C17.3341452,23.5111508 17.300793,23.387333 17.2361576,23.2796205",
    id: "Fill-6",
    fill: "#2F424F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6953777,25.3278973 L15.3794718,22.705884 L20.311889,25.4728453 C20.311889,25.4728453 21.6754396,21.7436223 21.5814016,21.5553831 C21.5755086,21.5432719 21.5716217,21.529228 21.5657286,21.5161505 L21.5441626,18.3888162 L15.3285033,18.3163421 L9.11441124,18.3888162 L9.09284519,21.5161505 C9.08695215,21.529228 9.08206217,21.5433363 9.07616913,21.5553831 C8.99492032,21.718498 10.6953777,25.3278973 10.6953777,25.3278973",
    id: "Fill-7",
    fill: "#E6E9EA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(5.955738, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9959844,12.3364305 C17.9959844,18.0938952 12.6556306,23.3923578 9.3727649,23.3923578 C6.09134113,23.3923578 0.749984191,18.0938952 0.749984191,12.3364305 C0.749984191,6.57903018 4.6113088,2.78132729 9.3727649,2.78132729 C14.1347225,2.78132729 17.9959844,6.57903018 17.9959844,12.3364305",
    id: "Fill-8",
    fill: "#E5C3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.708793,1.83117682 C13.2414872,0.466281718 8.14644702,-1.49444644 3.42222996,1.83117682 C-0.303930733,4.45428528 0.0722211642,11.0672011 0.0722211642,11.0672011 C0.0722211642,11.0672011 4.96200775,12.3364305 10.5619064,9.04907352 C14.1817415,6.92323345 15.4434177,9.08527831 16.0918409,10.9675413 C16.724591,12.7994911 17.9959844,12.3364305 17.9959844,12.3364305 C17.9959844,12.3364305 19.4007237,6.19656064 14.708793,1.83117682",
    id: "Fill-10",
    fill: "#2F424F",
    transform: "translate(9.127317, 6.194847) scale(-1, 1) translate(-9.127317, -6.194847) "
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-13",
    fill: "#FFFFFF",
    points: "15.3794718 32.9837303 9.09290788 21.5161505 7.3552115 23.6923681 9.39652516 25.3027729 9.03115628 26.8488209 15.3794718 32.9837303"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-14",
    fill: "#FFFFFF",
    points: "15.3794718 32.9837303 21.5657286 21.5161505 23.3895011 23.6923681 21.3501936 25.3027729 21.7146221 26.8488209 15.3794718 32.9837303"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomAvatar);
export default __webpack_public_path__ + "static/media/custom-avatar.81771e232855191d785c6b082a929881.svg";
export { ForwardRef as ReactComponent };